export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6220.6bd5f85d.jpg";